import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=32ca7b79&scoped=true&"
import script from "./Deposits.vue?vue&type=script&lang=ts&"
export * from "./Deposits.vue?vue&type=script&lang=ts&"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=32ca7b79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca7b79",
  null
  
)

export default component.exports